<ng-container *ngIf="block.set_file_privati && block.set_file_privati.length">
    <div class="container-general p-3" [ngClass]="{
            'col-md-9 m-auto': column === '4',
            'border-custom': block.titolo
        }" [ngStyle]="{'padding': block.titolo ? '48px 32px': '0'}">
        <div class="container-general__container-title-general">
            <p class="text-brand-10 ls-label-medium-semibold text-uppercase text-center mb-3"
                [innerHTML]="block.titolo"></p>
            <p class="text-brand-10 ls-label-medium m-0" [innerHTML]="block.descrizione_generale"></p>
        </div>
        <ng-container
            *ngIf="dataFile && dataFile.length && this.block.set_file_privati && this.block.set_file_privati.length">
            <ng-container *ngFor="let item of dataFile; let i=index">
                <a *ngIf="item" class="no-anchor no-print" [href]="item.link" target="_blank">
                    <div
                        class="container-general__container-enclosure d-flex flex-row justify-content-between my-2 w-100">
                        <div class="col-11 d-flex flex-column">
                            <p *ngIf="item.title" [innerHTML]="item.title"></p>
                            <div class="scroll-div">
                                <p *ngIf="item.description"
                                    class="ls-p-extra-small text-warning-30 my-0 scroll-animation-top"
                                    [innerHTML]="item.description">
                                </p>
                            </div>
                        </div>
                        <div class="col-1 justify-content-center">
                            <div class="no-anchor fw-bold arrow-animation w-100 h-100">
                                <img loading="lazy" src="./assets/images/vertical-align.png" alt="download icon"
                                    [ngStyle]="{'right': column === '1' ? '12px' : '0'}">
                                <div class="gold-animation"></div>
                            </div>
                        </div>
                    </div>
                </a>
                <app-sample-print [title]="item.title" [description]="item.description"></app-sample-print>
            </ng-container>
        </ng-container>
    </div>
</ng-container>